import { CountryCode } from '@domains/country';

export enum UserRoles {
  IDM_TECH = 'idm_tech',
  IDM_LEAD = 'idm_lead',
}

export const getRolesFromUser = ({
  roles,
  countryCode,
}: {
  roles: string[];
  countryCode: CountryCode[];
}) => {
  return roles.filter(role => !countryCode.includes(role as CountryCode));
};
